export default __webpack_public_path__ + "static/media/480_portfolio02-it-mobile.d65abc0c.png";